import { Modal, Select, Label, Spinner } from "flowbite-react";
import { useState, useEffect } from "react";
import { LuCloudCog } from "react-icons/lu";
import HiddenText from "./HiddenText";
import { envs } from "../constants";
import axiosInstance from "../utils/axiosInstance";
import { Toolbar } from "@mui/material";

export default function ApiKeysModal({ brand, onClose, show }) {
  const [environment, setEnvironment] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [keys, setKeys] = useState({});
  const [isRevealed, setIsRevealed] = useState([]);
  useEffect(() => {
    if (environment === null) return;
    if (brand?.id === null) return;
    setIsLoading(true);
    setIsRevealed([false, false, false]);
    setKeys({});
    axiosInstance
      .get(`/v51/brands/${brand?.id}/api-key?environment=${environment}`)
      .then((res) => {
        setKeys({
          v4: {
            frontend: res?.data?.v4?.frontend || "Key not available",
            backend: res?.data?.v4?.backend || "Key not available",
          },
          v5: {
            backend: res?.data?.v5?.backend || "Key not available",
          },
        });
        setIsLoading(false);
      })
      .catch((e) => {
        setKeys("Error fetching keys");
        setIsLoading(false);
      });
  }, [environment]);

  const handleToggle = (index) => {
    let newRevelaed = isRevealed.map(() => false);
    newRevelaed[index] = !isRevealed[index];
    setIsRevealed(newRevelaed);
  };

  return (
    <Modal
      show={show}
      onClose={() => {
        setEnvironment(null);
        setIsRevealed([false, false, false]);
        setKeys({});
        onClose();
      }}
    >
      <Modal.Header>API Keys</Modal.Header>
      <Modal.Body className="flex flex-col space-y-5">
        {isLoading ? (
          <Spinner />
        ) : (
          <>
            <Label htmlFor="environment" value="Select the environment" />
            <Select
              value={environment}
              onChange={(event) => {
                setEnvironment(event.target.value);
              }}
              id="environment"
              required
              icon={LuCloudCog}
            >
              <option selected disabled value={null}>
                Select an environment
              </option>
              {envs.map((env, index) => (
                <option value={env.value}>{env.name}</option>
              ))}
            </Select>
            {environment && (
              <>
                <Label>V4 Frontend key</Label>
                <HiddenText
                  value={keys?.v4?.frontend}
                  isRevealed={isRevealed[0]}
                  onChange={() => handleToggle(0)}
                />
                <Label>V4 Backend key</Label>
                <HiddenText
                  value={keys?.v4?.backend}
                  isRevealed={isRevealed[1]}
                  onChange={() => handleToggle(1)}
                />
                <Label>V5 Backend key</Label>
                <HiddenText
                  value={keys?.v5?.backend}
                  isRevealed={isRevealed[2]}
                  onChange={() => handleToggle(2)}
                />
              </>
            )}
          </>
        )}
      </Modal.Body>
      <Modal.Footer></Modal.Footer>
    </Modal>
  );
}
